@if (payNowDisabled()) {
  <span>{{ 'makeAPayment.billMeLater' | cxTranslate }}</span>
} @else {
  <div #paymentDrop="ngbDropdown" ngbDropdown class="d-inline-block paymentMethodsDropdown {{mix()}}" [autoClose]="'outside'">
    <button type="button"
            class="text-left paymentMethodsDropdown__paymentDropdownButton c-button c-button--secondary mx-1 px-3"
            id="dropdownForm1"
            ngbDropdownToggle
            [disabled]="splitOrder()"
    >
      @if (
        (selectedPaymentMethod() && selectedPaymentMethod().PaymentMethod === PaymentsMods.BILL_ME_LATER) ||
        noDefaultMethodAndEligibleToBillMeLater() ||
        noMethodsAddedAndEligibleToBillMeLater()
        ) {
        {{ 'makeAPayment.billMeLater' | cxTranslate }}

        @if (shouldBillMeLaterBeDefault()) {
          ({{ 'makeAPayment.default' | cxTranslate }})
        }
      } @else if (selectedPaymentMethod()) {
        {{ selectedPaymentMethod().creditCardName }}
        {{ getPaymentMethodName(selectedPaymentMethod()?.displayCardNumber) }}
        @if (selectedPaymentMethod().creditCardDefault) {
          ({{ 'makeAPayment.default' | cxTranslate }})
        }
      } @else {
        {{ 'makeAPayment.selectPaymentMethod' | cxTranslate }}
      }
    </button>
    <div ngbDropdownMenu aria-labelledby="dropdownForm1">
      @if (shouldDisplayWalletButton()) {
        <button class="paymentMethodsDropdown__walletButtonWrapper dropdown-toggle py-3"
                type="button"
                (click)="walletClick($event)"
                ngbDropdownItem
        >
          <span class="paymentMethodsDropdown__walletButton">{{ 'makeAPayment.walletButtonText' | cxTranslate }}</span>
          <section class="paymentMethodsDropdown__cardsDropdown d-none">
            <ng-select
              [multiple]="false"
              [clearable]="false"
              [ngModel]="selectedPaymentMethod()"
              (ngModelChange)="selectedPaymentMethod.set($event)"
              [ngModelOptions]="{ standalone: true }"
              [isOpen]="true"
              [closeOnSelect]="true"
              [hideSelected]="true"
              (change)="paymentDrop.close()"
              class="paymentMethodsDropdown__ngSelect"
            >
              @for(method of allPaymentsMethods(); track method.cardId) {
                <ng-option [value]="method">
                  {{ method.creditCardName }}
                  {{ getPaymentMethodName(method.displayCardNumber) }}
                  @if (method.creditCardDefault) {
                    (Default)
                  }
                </ng-option>
              }
            </ng-select>
          </section>
        </button>
      }
      @if (eligiblePaymentMethods()?.includes(PaymentsMods.BILL_ME_LATER)) {
        <button class="py-3 paymentMethodsDropdown__billMeLaterBtn" type="button" ngbDropdownItem (click)="selectBillMeLater(); paymentDrop.close()">{{ 'makeAPayment.billMeLater' | cxTranslate }}</button>
      }

      @if (eligiblePaymentMethods()?.includes(PaymentsMods.ECHECK)) {
        <button class="py-3 paymentMethodsDropdown__paymentDropDownBtn d-flex align-items-center"
                type="button"
                ngbDropdownItem
                (click)="onOpenAddECIframe(); paymentDrop.close()"
        >
          <img class="paymentMethodsDropdown__bankImg my-auto d-block mr-2" src="icons/account_balance_purple.svg" alt="bank" />
          <span>{{ 'makeAPayment.addUseEcheck' | cxTranslate }}</span>
        </button>
      }

      @if (eligiblePaymentMethods()?.includes(PaymentsMods.CREDIT_CARD)) {
        <button class="py-3 paymentMethodsDropdown__paymentDropDownBtn d-flex align-items-center"
                type="button"
                ngbDropdownItem
                (click)="onOpenAddCardIframe(); paymentDrop.close()"
        >
          <img class="paymentMethodsDropdown__cardImg my-auto d-block mr-2" src="icons/add_card_purple.svg" alt="bank" />
          <span>{{ 'makeAPayment.addUseCreditCard' | cxTranslate }}</span>
        </button>
      }

      @if (shouldDisplayWalletButton()) {
        <button (click)="goToProfilePage()" class="py-3 paymentMethodsDropdown__paymentDropDownBtn" type="button" ngbDropdownItem>
          {{ 'makeAPayment.addManagePayments' | cxTranslate }}
        </button>
      }
    </div>
  </div>
}
